import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';
import {
  ConfirmDialogData,
  ConfirmDialogService,
} from '../../services/confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    FormsModule,
    TextareaModule,
  ],
})
export class ConfirmDialogComponent implements OnInit {
  visible = false;
  isLoading = false;
  inputValue = '';
  showInputError = false;
  dialogData: ConfirmDialogData = {
    header: '',
    message: '',
  };

  constructor(private confirmDialogService: ConfirmDialogService) {}

  ngOnInit(): void {
    this.confirmDialogService.confirm$.subscribe((data) => {
      this.dialogData = data;
      this.visible = true;
      this.isLoading = false;
      this.inputValue = '';
      this.showInputError = false;
    });
  }

  // Boton de confirmacion de acción
  async onAccept(): Promise<void> {
    // Validar si el input es requerido
    if (this.dialogData.requireInput && this.dialogData.inputRequired) {
      if (!this.inputValue || this.inputValue.trim() === '') {
        this.showInputError = true;
        return;
      }
    }

    if (this.dialogData.onAccept) {
      this.isLoading = true;
      this.showInputError = false;

      try {
        await this.dialogData.onAccept(this.inputValue);
        this.visible = false;
      } catch (error) {
        console.error('Error al aceptar: ', error);
      } finally {
        this.isLoading = false;
      }
    } else {
      this.visible = false;
    }
  }

  // Boton de rechazo de acción
  async onReject(): Promise<void> {
    if (this.dialogData.onReject) {
      this.isLoading = true;
      try {
        await this.dialogData.onReject();
        this.visible = false;
      } catch (error) {
        console.error('Error en reject:', error);
      } finally {
        this.isLoading = false;
      }
    } else {
      this.visible = false;
    }
  }

  onDialogHide(): void {
    this.isLoading = false;
    this.inputValue = '';
    this.showInputError = false;
  }
}
